<template>
<transition name="modal" >
<div class="modal-mask">
    <div class="modal-dialog modal-dialog-centered modal-md">
        <div class="modal-content">
          <div class="popup_header">
            <slot name="header"> </slot>
          </div>
          <div class="modal-body">
            <slot name="body"> 
            </slot>
          </div>
          <div class="modal-footer popup_bottom">
            <slot name="footer">
            </slot>
          </div>
        </div>
    </div>
</div>
</transition>
</template>

<script>
export default {

}
</script>

<style>

</style>